import EditTemplate from "../_templates/EditTemplate";
import { matchSchema } from "../../../schemas/match.schema";
import { getMatch, updateMatch } from "../../../api/matches.api";

export default function EditMatch() {
  return (
    <EditTemplate
      title="Edit Match"
      schema={matchSchema}
      fetchFn={getMatch}
      updateFn={updateMatch}
      redirectPath="/cricket/matches"
    />
  );
}
